import React from 'react'
import { Modal, Button } from 'antd'
import LocationMap from '../../../PickLocation'

const ViewMap = (props) => {
  const { visible, onCancel, locationList, hero, heroConfigs } = props

  // ฟังก์ชันเปิด Google Maps ในแท็บใหม่
  const openGoogleMaps = () => {
    if (locationList && locationList.length > 0) {
      const { lat, lng } = locationList[0] // ใช้ตำแหน่งแรก
      const mapUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
      window.open(mapUrl, '_blank')
    }
  }

  return (
    <Modal
      title="View Map"
      width={770}
      visible={visible}
      footer={[
        <Button key="newTab" type="primary" onClick={openGoogleMaps}>
          Open in Google Maps
        </Button>,
        <Button key="cancel" onClick={onCancel}>
          Close
        </Button>,
      ]}
      onCancel={onCancel}
    >
      {locationList && locationList.length > 0 && (
        <LocationMap
          draggable={false}
          hero={hero}
          locationList={locationList}
          heroConfigs={heroConfigs}
        />
      )}
    </Modal>
  )
}

export default ViewMap